export const STROM = 'Strom';
export const SOUHRN = 'Souhrn';
export const STATISTIKA = 'Statistika';
export const PLAN = 'Plán';
export const SKUTECNOST = 'Skutečnost';
export const PRUBEH = 'Průběh';
